import React from 'react';

const Spinner = () => (
  <div className="flex">
    <span className="flex h-3 w-3 relative ">
      <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-gray-400 opacity-75"></span>
    </span>
    <span className="flex h-3 w-3 relative ml-2">
      <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-gray-400 opacity-75"></span>
    </span>
    <span className="flex h-3 w-3 relative ml-2">
      <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-gray-400 opacity-75"></span>
    </span>
  </div>
);

export default Spinner;
